export enum ExportGrouping {
    BY_WORK_ITEM             = 'byWorkItem',
    BY_USER                  = 'byUser',
    BY_WORK_ITEM_AND_USER    = 'byWorkItemAndUser',
    BY_DATE                  = 'byDate',
    BY_TIME_REPORTS          = 'timeReports'
}